// eslint-disable-next-line import/prefer-default-export
export class Subset {
    value: number
}
